<script>
    import Layout from "../../../layouts/main.vue";
    import PageHeader from "@/components/page-header";
    import appConfig from "../../../../app.config";
    import axios from 'axios';
    //import moment from 'moment';
    export default {
        page: {
            title: "Invoice Details",
            meta: [{
                name: "description",
                content: appConfig.description
            }],
        },
        data() {
            return {
                title: "Invoice Details",
                items: [{
                        text: "Velzon",
                        href: "/",
                    },
                    {
                        text: "Invoice Details",
                        active: true,
                    },
                ],

                rangeDateconfig: {
                    mode: "range",
                    dateFormat: "Y-m-d",
                },
        
                invoice_listing:[],
                loadingDetail:false,
                loadingRoles:true,
                ButtonSeen:true,
                date: '',
                key_search:'',
                invoice_id:'',
                dtKey:0,

                name_as_per_nric:'',
                address:'',
                city:'',
                state_name:'',
                pnone_number:'',
                email:'',
                imei:'',
                invoice_number:'',
                issue_date:'',
                due_date:'',
                description:'',
                credit_applied:'',
                late_payment_charges:'',
                total_amount:''
                                
            };
        },
        method:{
            
    getCurrency() {
            return process.env.VUE_CURRENCY || 'SGD';
        },

            getInvoiceListing(){
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.get(process.env.VUE_APP_AR_API_BASEURL+'invoice/invoiceListing')
                .then(response => {
                    if (response) {
                        this.loadingRoles=false;
                        this.invoice_listing = response.data;
                        this.name_as_per_nric = this.invoice_listing[0].name_as_per_nric;
                        this.address = this.invoice_listing[0].address;
                        this.city = this.invoice_listing[0].city;
                        this.state_name = this.invoice_listing[0].state_name;
                        this.pnone_number = this.invoice_listing[0].pnone_number;
                        this.email = this.invoice_listing[0].email;
                        this.imei = this.invoice_listing[0].imei;
                        this.invoice_number = this.invoice_listing[0].invoice_number;
                        this.issue_date = this.invoice_listing[0].issue_date;
                        this.due_date = this.invoice_listing[0].due_date;
                        this.description = this.invoice_listing[0].description;
                        this.credit_applied = this.invoice_listing[0].credit_applied;
                        this.late_payment_charges = this.invoice_listing[0].late_payment_charges;
                        this.total_amount = this.invoice_listing[0].total_amount;
                        console.log(this.invoice_listing);
                    } 
                    else {
                        this.messageBag = ['No record.'];
                    }
                })
                .catch(error => {
                    this.messageBag = [error.error];
                });
            }
        },
        mounted() {
            
            
        },
        components: {
            Layout,
            PageHeader,
        },
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row justify-content-center">
            <div class="col-xxl-10">
                <div class="card" id="demo">
                    <div class="card-header border-bottom-dashed p-4">
                        <div class="d-sm-flex">
                            <div class="flex-grow-1">
                                <span
                        class="overflow-hidden d-flex align-items-center justify-content-center rounded"
                        style="height: 60px; width: 256px">
                        <img src="@/assets/images/CompAsia-logo.png"
                          class="card-logo card-logo-dark user-profile-image img-fluid" alt="logo dark" />
                        <img src="@/assets/images/CompAsia-logo.png"
                          class="card-logo card-logo-light user-profile-image img-fluid" alt="logo light" />
                      </span>
                                
                                <div class="mt-sm-5 mt-4">
                                
                                
                                </div>
                            </div>
                            <div class="flex-shrink-0 mt-sm-0 mt-3">
                                    <h5>CompAsia PTE. LTD. (201215376H)</h5>                                  
                                        100 Pasir Panjang Rd,<br>
                                        #06-01,<br>
                                        Singapore, 118518<br><br>
                                        03-860 29290<br>
                            </div>
                        </div>
                    </div>
                    <!--end card-header-->
                   
                    <div class="card-body p-4 border-top border-top-dashed">
            <div class="row g-3">
              <div class="col-sm-4">
                <h6 class="text-muted text-uppercase fw-semibold mb-3">Billing Address</h6>
                <input v-model='race' type="text" class="form-control mb-1" id="race" readonly />
                <textarea v-model="address" rows="4" class="form-control mb-1" id="address" placeholder="" readonly></textarea>
                <input v-model='race' type="text" class="form-control mb-1" id="race" readonly />
              </div>
              <div class="col-sm-3">
                
              </div>
              <!--end col-->
              <div class="col-sm-5">
                <h6 class="text-muted text-uppercase fw-semibold mb-3">xxxxx</h6>
                    <div class="row mb-1">
                        <div class="col-lg-3">
                            <label for="nameInput" class="form-label">Ref. No</label>
                        </div>
                        <div class="col-lg-9">
                            <input type="text" class="form-control" id="nameInput" placeholder="Enter your name">
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-lg-3">
                            <label for="websiteUrl" class="form-label">Issue Date</label>
                        </div>
                        <div class="col-lg-9">
                            <input type="url" class="form-control" id="websiteUrl" placeholder="Enter your url">
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-lg-3">
                            <label for="leaveemails" class="form-label">Due Date</label>
                        </div>
                        <div class="col-lg-9">
                            <input type="email" class="form-control" id="leaveemails" placeholder="Enter your email">
                        </div>
                    </div>
              </div>
              <!--end col-->
            </div>
            <!--end row-->
          </div>

                    <!--end card-body-->
                    <div class="card-body p-4">
                        <div class="table-responsive">
                            <table class="invoice-table table table-borderless table-nowrap mb-0">
                                <thead>
                                    <tr class="table-active">
                                        <th scope="col" style="width: 50px;">#</th>
                                        <th scope="col">Description</th>
                                        <th scope="col" class="text-end">Amount ({{ this.getCurrency() }})</th>
                                    </tr>
                                </thead>
                                <tbody id="products-list" class="col-lg-12">
                                    <tr>
                                        <th scope="row">01</th>
                                        <td>{{description}}</td>
                                        <td class="text-end">{{total_amount}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <!--end table-->
                        </div>
                        <div class="border-top border-top-dashed mt-2">
                                        
                          <table
                              class="table text-start table-borderless table-nowrap align-middle mb-0">
                              <tbody>
                                  <tr>
                                      <td class="text-end col-8"></td>
                                      <td class="text-end">Credit Applied</td>
                                      <td class="text-end col-2">{{credits_applied}}</td>
                                  </tr>
                                  <tr>
                                      <td class="text-end col-8"></td>
                                      <td class="text-end">Late Payment Charges</td>
                                      <td class="text-end col-2">{{late_payment_charges}}</td>
                                  </tr>
                                  <tr class="">
                                      <td class="text-end col-8"></td>
                                      <td scope="row" class="text-end border-top border-top-dashed"><h5>Total Amount</h5></td>
                                      <td class="text-end col-2 border-top border-top-dashed"><h5>595.74</h5></td>
                                  </tr>
                              </tbody>
                          </table>

                        </div>
                        <div class="mt-4">
                            <div class="alert alert-info">
                                <p class="mb-0"><span class="fw-semibold">NOTES:</span>
                                    <span id="note">{{notes}}
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div class="hstack gap-2 justify-content-end d-print-none mt-4">
                            <a href="javascript:window.print()" class="btn btn-success"><i
                                    class="ri-printer-line align-bottom me-1"></i> Print</a>
                            <a href="javascript:void(0);" class="btn btn-primary"><i
                                    class="ri-download-2-line align-bottom me-1"></i> Download</a>
                        </div>
                    </div>
                    <!--end card-body-->
                </div>
                <!--end card-->
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </Layout>
</template>